module.exports = __webpack_public_path__ + "img/Frame 818one2.73fb8e02.svg";